export default __webpack_public_path__ + "static/media/Cloudxier-aboutus-banner.1b767535.png";